/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 01/10/2021.
 */
import React, { Suspense } from 'react'
import { authStore } from '../../store/auth/authStore'
import { BellFilled, BellOutlined } from '@ant-design/icons'
import './header.scss'
import { HeaderSelectProject } from './HeaderSelectProject'
import { Badge, Button, Popover, Tooltip } from 'antd'
import { useProjects } from '../../hooks/useProjects'
import { Link, useParams } from 'react-router-dom'
import { analytics } from '../../util/analytics'

import formatDistance from 'date-fns/formatDistance'
import { notificationToLink, NotificationType, useNotifications } from '../../hooks/useNotifications'

export const Header = ({ headerHeight }) => {
  return (
    <div className="">
      <div
        className="container-fluid bg-white position-relative px-4 "
        style={{
          height: headerHeight,
          borderBottom: '1px solid rgba(0,0,0,.1)',
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.04)',
        }}
      >
        <div className="row h-100 ">
          <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start align-items-center">
            <Suspense fallback={'...'}>
              <HeaderSelectProject></HeaderSelectProject>
            </Suspense>
          </div>

          <div className="col-12 col-md-4 d-flex justify-content-center align-items-center"></div>

          <div className="col-12 col-md-4 d-flex justify-content-end align-items-center">
            <Suspense fallback="...">
              <SettingsMenu></SettingsMenu>
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  )
}

const SettingsMenu = () => {
  const { projectId } = useParams() as { projectId: string }

  const user = authStore((state) => state.user)
  const logoutFunc = authStore((state) => state.logout)
  const name = user?.attributes.email || ''
  const letter = user?.attributes.email ? user?.attributes.email[0] : ''

  const { data } = useProjects()

  const logout = () => {
    analytics.track('LOGOUT')

    logoutFunc()
  }

  const typeArr = projectId
    ? data.filter((user) => {
        //
        // This might happen if project has been deleted, but the reference is still connected to the user
        //
        if (!user?.projects) {
          return null
        }

        return user.projects._id === projectId
      })
    : ''

  const type = typeArr.length > 0 ? typeArr[0].type : ''

  const content = (
    <div className="px-2 mt-2 " style={{ width: 300 }}>
      <div className="d-flex mb-3 align-items-center">
        <div
          className="bg-primary rounded-circle p-2 d-flex justify-content-center align-items-center "
          style={{ width: 35, height: 35 }}
        >
          <div className="text-white " aria-label="Customise options" style={{ userSelect: 'none', outline: 'none' }}>
            <p className="fw-bold">{letter.toUpperCase()}</p>
          </div>
        </div>

        {type ? (
          <div className="ms-2">
            <p className="p-mini mb-0 fw-bold text-black text-capitalize">{type.toLowerCase()}</p>
            <p className="text-truncate" style={{ marginTop: -1, maxWidth: 240 }}>
              {name}
            </p>
          </div>
        ) : (
          <div className="ms-2">
            <p className="p-mini mb-0 fw-bold text-black text-capitalize"> </p>
            <p className="text-truncate" style={{ marginTop: -1, maxWidth: 240 }}>
              {name}
            </p>
          </div>
        )}
      </div>

      <Button onClick={logout} type="default" className="mt-2 w-100">
        <p className="fw-bold">Logout</p>
      </Button>
    </div>
  )

  const copyToClipboard = () => {
    navigator.clipboard.writeText(name)
  }

  return (
    <div className=" ">
      <div className="d-flex noselect align-items-center">
        <p className="p-small fw-bold mt-1  ms-1 me-1 text-capitalize">{type.toLowerCase()}</p>
        <Tooltip
          classNames={{ root: 'mw-100' }}
          placement="bottom"
          title={<p className="py-1 px-2">{name}</p>}
          styles={{ container: { maxWidth: '100%', /* wordWrap: 'unset'*/ color: 'black' } }}
          color={'#f3f3f3'}
        >
          <p
            onClick={copyToClipboard}
            className="p-small opacity-50 mt-1  ms-1 text-truncate"
            style={{ maxWidth: 170 }}
          >
            {name}
          </p>
        </Tooltip>

        <Suspense>
          <Notification></Notification>
        </Suspense>
        <Popover placement="bottomRight" content={content}>
          <div
            className="ms-4 bg-primary rounded-circle p-2 d-flex justify-content-center align-items-center"
            style={{ width: 33, height: 33 }}
          >
            <button
              className="text-white "
              aria-label="Customise options"
              style={{ userSelect: 'none', outline: 'none' }}
            >
              <p className="fw-bold">{letter.toUpperCase()}</p>
            </button>
          </div>
        </Popover>
      </div>
    </div>
  )
}

const Notification = () => {
  const { projectId } = useParams() as { projectId: string }
  const { activeNotifications, data } = useNotifications(projectId, true)

  //const href = window.location.origin

  const unreadNotifications = activeNotifications.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )

  const now = new Date()

  const notificationContent = (
    <div className="mt-2 position-relative" style={{ minWidth: 300 }}>
      <div className="pt-3  px-3">
        <p className="p-small  fw-bold text-black">Latest updates</p>
      </div>
      <div
        className="h-100 position-absolute "
        style={{
          pointerEvents: 'none',
          zIndex: 10,
          width: 410,
          bottom: 32,
          background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 70%, rgba(255, 255, 255, 1) 100%)',
        }}
      ></div>
      {unreadNotifications.length > 0 ? (
        <div className="px-3 notification-list position-relative" style={{ maxWidth: 420, maxHeight: 290 }}>
          {unreadNotifications.map((item: NotificationType, index: number) => {
            const title = item.configId.content.banner.title
            const body = item.configId.content.banner.body
            const button = item.configId.content.banner.button

            const d = formatDistance(new Date(item.createdAt), now, {
              addSuffix: true,
            })

            //
            // should also consider the item.configId.content.view
            // which tells you where to go
            // might not work
            const link = notificationToLink(item)

            return (
              <Link key={index} to={link} className="text-decoration-none text-black">
                <div className="opacityHover mb-2 py-2 text-decoration-none">
                  <p className="mb-0 text-black p-mini opacity-75">
                    {d} - {item.target?.subjectId?.displayId}
                  </p>
                  <p className="mb-0 text-black fw-bold">{title}</p>
                  <p className="opacity-75 text-truncate ">{body}</p>

                  <p className="text-decoration-underline opacity-75 text-truncate">{button}</p>
                </div>
              </Link>
            )
          })}
          {unreadNotifications.length > 2 && <div className="mb-6"></div>}
        </div>
      ) : (
        <div className="px-3 notification-list pb-3" style={{ maxWidth: 400 }}>
          <p>You have no unread notifications</p>
        </div>
      )}

      {data.length > 0 ? (
        <div className="px-3 pb-2  pt-2 opacity-75">
          <Link to="/notifications" className="text-decoration-none ">
            <p className="p-small fw-bold text-black">Show all notifications</p>
          </Link>
        </div>
      ) : null}
    </div>
  )

  return (
    <Popover
      styles={{
        container: {
          padding: '0 0 0 0',
        },
      }}
      placement="bottomRight"
      content={notificationContent}
    >
      {unreadNotifications.length > 0 ? (
        <Badge count={unreadNotifications.length}>
          <BellFilled className="pointer opacityHover" style={{ fontSize: '1.5rem' }} />
        </Badge>
      ) : (
        <BellOutlined className="pointer  mx-3" style={{ fontSize: '1.5rem' }} />
      )}
    </Popover>
  )
}
